import { forwardRef } from 'react';

import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './CustomSharedLink.scss';

/**
 * @typedef {Object} CustomSharedLinkProps
 * @property {function} [onClick] - Click handler
 * @property {React.ReactNode} [children=null] - Link content
 * @property {string} href - Link URL
 * @property {string} [target=null] - Link target (e.g. '_blank' for a new tab)
 * @property {string} [className=''] - Additional CSS class name
 * @property {('primary'|'secondary'|'tertiary'|'link'|'inline-link'|'attention'|'details')} [action='inline-link'] - Link style
 * @property {('small'|'medium'|'large'|'')} [size=''] - Link size
 */

/**
 * @type {React.ForwardRefExoticComponent<CustomSharedLinkProps & React.RefAttributes<HTMLAnchorElement>>}
 */
const CustomSharedLink = forwardRef(
    (
        {
            onClick,
            children = null,
            href,
            target = null,
            className = '',
            action = 'inline-link',
            size = '',
            loading: unusedLoading,
            ...rest
        },
        ref,
    ) => {
        const isRightArrow = action === 'details';

        return (
            <a
                ref={ref}
                href={href}
                className={getClassName(
                    styles.link,
                    styles[`link--${action}`],
                    size ? styles[`link--${size}`] : '',
                    className,
                )}
                onKeyPress={onClick}
                onClick={onClick}
                target={target}
                {...rest}
            >
                {children}
                {isRightArrow ? <div className={styles.arrow} /> : null}
            </a>
        );
    },
);

CustomSharedLink.displayName = 'CustomSharedLink';

export default CustomSharedLink;
